import PopupComponent from '../popup-component';
import template from './template';

export default class PairPopup extends PopupComponent {
  constructor(config) {
    super();
    this.popup = null;
    this.statusButton = null;
    this.hasHelpShown = false;
    this.currentIndex = 0;
    this.currentValue = ['x', 3, 3, 3, 3];
    this.inputAmount = 4;
    this.colorAmount = 4;
    this.inputs = [];
    this.challengeColorMap = [
      [0, 158, 255],
      [227, 0, 122],
      [255, 221, 0],
      [255, 255, 255],
      [94, 185, 0],
      [0, 0, 0],
    ];

    const popupConfig = {
      id: 'popup_content_connect',
      initializedCallback: () => this._initColors(),
      buttons: [
        {
          id: 'cancel',
          class: 'negative',
          shouldClose: true,
          text: this.t('defaultPopupNegativeButton'),
          callback: () => config.onCancel(),
        },
        {
          id: 'connect',
          class: 'positive',
          shouldClose: true,
          text: this.t('connectPopupConnectButton'),
          callback: () => config.onProceed(this.currentValue.join('')),
        },
      ],
    };

    this.popup = this.create(popupConfig);
    this.createContentElement('popup_content_connect', template);
  }

  // Private
  _initColors() {
    const choices = this.popup.wrapperElement.querySelectorAll('.color_code .choices div');

    for (let i = 0; i < choices.length; i++) {
      const el = choices[i];
      if (i < this.colorAmount) {
        this._setColorForElement(el, i);
        el.addEventListener('click', () => this._setValue(i));
      } else {
        el.style.display = 'none';
      }

      const inputs = this.popup.wrapperElement.querySelectorAll('.color_code .selection div');
      for (let j = 0; j < inputs.length; j++) {
        const input = inputs[j];
        input.addEventListener('click', () => this._setCurrentIndex(j));
      }

      this._updateInputColors();
    }
  }

  _setCurrentIndex(index) {
    this.currentIndex = index;
    this._updateInputColors();
  }

  _setValue(value) {
    this.currentValue[this.currentIndex + 1] = value;
    this._setCurrentIndex((this.currentIndex + 1) % this.inputAmount);
  }

  _updateInputColors() {
    const inputs = this.popup.wrapperElement.querySelectorAll('.color_code .selection div');
    let inputIndex = 0;
    for (let i = 0; i < this.currentValue.length; i++) {
      if (!(inputIndex < inputs.length)) {
        continue;
      }

      if (this.currentValue[i] === 'x') {
        continue;
      }

      const colorIndex = this.currentValue[i];
      this._setColorForElement(inputs[inputIndex], colorIndex);
      if (inputIndex === this.currentIndex) {
        inputs[inputIndex].classList.add('active');
      } else {
        inputs[inputIndex].classList.remove('active');
      }

      inputIndex++;
    }
  }

  _setColorForElement(element, index) {
    if (index >= this.colorAmount && index >= this.challengeColorMap.length) {
      console.warn('Not coloring element because of wrong index.');
      return;
    }

    const color = this.challengeColorMap[index];
    element.style.backgroundColor = this._generateCSSColor(color);
    element.style.border = `1px solid ${this._generateCSSColor(color, 0.8)}`;

    if (color[0] + color[1] + color[2] > 500) {
      element.classList.remove('grid-white');
      element.classList.add('grid-black');
    } else {
      element.classList.remove('grid-black');
      element.classList.add('grid-white');
    }
  }

  _generateCSSColor(rgb, scale = 1) {
    const c = val => (val * scale).toFixed(0);
    const r = `rgb(${c(rgb[0])}, ${c(rgb[1])}, ${c(rgb[2])})`;
    return r;
  }
}
